import React, { FunctionComponent, ReactNode } from "react"
import s from "./Grid.less"

interface iProps {
  children: ReactNode
}

const Grid: FunctionComponent<iProps> = ({ children }) => {
  return (
    <div className={s.root}>
      <div className={s.grid}>{children}</div>
    </div>
  )
}

export default Grid
